module.exports = __webpack_public_path__ + "resources/img/img_edb_2_jp.2e9ee90645b798eb0fe2edfd107ce364.png";